import React from "react";
function Footer(props){
    return(
        <div className="footer">
            <p>Ⓒ Created by Aniket Chauhan</p>
        </div>
    );
}

export default Footer;